import { tellescopeApiConfig, type TellescopeRouteTypeMap } from 'tellescope-functions/client'
import { backendClient } from '@/utils/backendClient'

export const tellescopeVendorSyncApi = backendClient<TellescopeRouteTypeMap>(tellescopeApiConfig)
